<template>
  <div class="line-gauge" :style="{ height: styleBindings.height }">
    <div
      v-if="value > 0"
      class="lg-position"
      :style="styleBindings"
    />
  </div>
</template>

<script>
export default {
  name: 'line-gauge',

  props: {
    value: {
      type: Number,
      default: 50,
    },
    bgColor: {
      type: String,
      default: '#00c896',
    },
    height: {
      type: Number,
      default: 8,
    },
  },

  computed: {
    styleBindings() {
      return {
        width: `${this.value}%`,
        height: `${this.height}px`,
        'background-color': this.bgColor,
        'border-color': this.bgColor,
      };
    },
  },
};
</script>

<style lang="scss">
  .line-gauge {
    position: relative;
    background-color: #f0f0f0;
    border-radius: 6px;
    z-index: 1;

    .lg-position {
      position: relative;
      border-top-left-radius: 25px;
      border-bottom-left-radius: 25px;
      z-index: 2;
    }
  }
</style>
